export default __webpack_public_path__ + "static/media/704.550a3235.png";